import vSelect from 'vue-select';
import track from "./track";

export default {

    components: {
        vSelect
    },

    data() {
        return {
            form: {
                name: null,
                email: null,
                entity: null,
                street: null,
                number: null,
            },
            loading: {
                check: false,
            },
            status: null,
            nameHasError: false,
            emailHasError: false,
            entityHasError: false,
            streetHasError: false,
            numberHasError: false,
            privacy_alert: true,
            showAfter: false,
            accept: false,
            query: null,
            streetQuery: null,
            numberQuery: null,
            debounceEntities: null,
            debounceStreets: null,
            debounceNumbers: null,
            gis: {
                entities: [],
                streets: [],
                numbers: [],
            },
            inputType: 0
        }
    },

    methods: {

        checkEmail () {
            if (!this.form.email) return false
            let re = /[@]/
            return re.test(this.form.email)
        },
        checkPhone () {
            if (!this.form.email) return false
            let re = /^\d{9}$/
            return re.test(this.form.email)
        },
        showErrors(){
            // if (!this.checkEmail()) {
            //     this.emailHasError = true;
            // }
            if (!this.checkPhone()) {
                this.emailHasError = true;
            }else {
                this.emailHasError = false;
            }
            if (!this.form.name) {
                this.nameHasError = true;
            }
            if (!this.query) {
                this.entityHasError = true;
            }
            if (!this.form.street) {
                this.streetHasError = true;
            }
            if (!this.form.number) {
                this.numberHasError = true;
            }
            if (!this.accept) {
                this.privacy_alert = false;
            }

        },
        fetchEntities(value) {
            if (!value || value.length <=2) {
                this.gis.entities = []
                return;
            }
            clearTimeout(this.debounceEntities);
            let type = 'ent';
            this.debounceEntities = this.fetch(value, type);
        },
        fetchStreets(value) {
            if (!value || value.length <=2) {
                this.gis.streets = []
                this.numberQuery = null
                return;
            }
            clearTimeout(this.debounceStreets);
            let type = 'road';
            this.debounceStreets = this.fetch(value, type, this.query.code);
        },
        fetchNumbers(value) {
            if (!value || value.length <=0) {
                this.gis.numbers = []
                return;
            }
            clearTimeout(this.debounceNumbers);
            let type = 'num';
            if(this.streetQuery.code === '0000'){
                this.gis.numbers = [{ label: value,  code: '0000', level: '0000' }]
            }
            else this.debounceNumbers = this.fetch(value, type, this.streetQuery.code);
        },
        fetch(value, type, code = null) {
            return setTimeout(async () => {
                try {
                    let dataInfo = {
                        type: type,
                        name: value,
                        coverage_type: 'new'
                    }
                    if (type === 'road') {
                        dataInfo.municipality_id = code
                    } else if (type === 'num') {
                        dataInfo.road_id = code
                    }
                    let res = await axios.post('/coverage/search', dataInfo)
                    const data = res.data?.data ?? [];

                    if (type === 'ent') {
                        this.gis.entities = data.map(item => ({ label: item.n, code: item.c, e_code: item.ec, level: item.l }));
                    } else if (type === 'road') {
                        if(data.length === 0){
                            this.gis.streets = [{ label: value,  code: '0000', level: '0000' }]
                        }else {
                            this.gis.streets = data.map(item => ({ label: item.n,  code: item.c, level: item.ec }));
                        }
                    } else if (type === 'num'){
                        let isInArray = false;
                        data.forEach(el => {
                            if(el.n === value){
                                isInArray = true;
                                return;
                            }
                        })
                        if(!isInArray){
                            this.gis.numbers = [{ label: value,  code: '0000', level: '0000' }]
                        }else {
                            this.gis.numbers = data.map(item => ({ label: item.n,  code: item.c, level: item.rc }));
                        }
                    }
                } catch (e) {
                    console.error(e.message)
                    this.gis.entities = [];
                    this.gis.streets = [];
                    this.gis.numbers = [];
                }
            }, 250);
        },

        async check() {
            if(!this.canSearch){
                return
            }
            this.status = null
            this.loading.check = true
            this.showAfter = true
            this.form.entity = this.query
            this.form.street = this.streetQuery
            this.form.number = this.numberQuery
            trackFbq('track', 'Lead')
            try{
                if(window.dataLayer){
                    dataLayer.push({'event': 'homeLeadFormCompleted'})
                }
            } catch (error) {
                console.error(error)
            }
            try {
                let params = {
                    name: this.form.name,
                    email: this.form.email,
                    municipality_code: this.form.entity.code,
                    entity_name: this.form.entity.label,
                    entity_code: this.form.entity.e_code,
                    entity_level: this.form.entity.level,
                    street_code: this.form.street.code,
                    street_name: this.form.street.label,
                    number_code: this.form.number.code,
                    number_name: this.form.number.label,
                    coverage_type: 'new',
                }
                let cookies = document.cookie;
                if(cookies.includes("girona")){
                    track.event({
                        eventCategory: "girona",
                        eventAction: "check-coverage",
                        eventLabel: params.entity_code ?? "UNKNOWN"
                    })
                }else {
                    track.event({
                        eventCategory: "home",
                        eventAction: "check-coverage",
                        eventLabel: params.entity_code ?? "UNKNOWN"
                    })
                }
                let res = await axios.post('/coverage/landing', params)
                this.status = res.data.data?.status ?? null
                this.address = res.data.data?.address ?? null

            } catch (e) {
                console.log("error", e.message)
                console.log(e.response.data.errors)
            } finally {
                this.loading.check = false
            }
        },

        reload() {
            this.loading.check = false
            this.status = null
            this.form.number = null
            this.form.entity = null
            this.gis.entities = []
            this.gis.streets = []
            this.gis.numbers= []
            this.query = null
            this.form.street = null
            this.showAfter = false
            this.accept= false
        }
    },

    watch: {
        status: function (newValue, oldValue){
            if(newValue){
                this.$refs.options.style.display = 'block'
            }else{
                this.$refs.options.style.display = 'none'
            }
        },
        'query': function(newValue, oldValue){
            if(newValue){
                $('.coverage-street').removeClass('disabled');
            }else{
                $('.coverage-street').addClass('disabled');
                $('.coverage-number').addClass('disabled');
                this.streetQuery = null
                this.numberQuery = null
            }
        },
        'streetQuery': async function (newValue, oldValue) {
            if (newValue) {
                let dataInfo = {
                    type: 'allNum',
                    name: newValue.code,
                    id: this.streetQuery.code,
                    coverage_type: 'new'
                }
                $('.coverage-number').removeClass('disabled');
                let res = await axios.post('/coverage/search', dataInfo);
                console.log(res)
                const data = res.data?.data ?? [];
                if (data.length === 1){
                    this.numberQuery = {
                        label: data[0].n,
                        code: data[0].c,
                        level: data[0].rc
                    }
                }else if(data.length >= 2){
                    this.gis.numbers = data.map(item => ({ label: item.n,  code: item.c, level: item.rc }));
                }
            } else {
                $('.coverage-number').addClass('disabled');
                this.numberQuery = null
            }
        }
    },
    created() {
        this.inputType = new Date().getTime() % 2;
    },
    mounted() {
        this.$refs.options.classList.add('mounted')
        this.$refs.searching.classList.remove('hidden')
    },
    computed: {
        hasStatus() {
            return !!this.status
        },

        canSearch() {
            // if(!this.checkEmail()) return false
            if(!this.checkPhone()) {
                console.log('canSearch');
                this.emailHasError = true;
                return false
            }else {
                this.emailHasError = false;
            }
            if(!this.form.name) return false
            if(!this.query) return false
            if(!this.streetQuery) return false
            if(!this.numberQuery) return false
            if(!this.accept) return false
            return true
        },

        statusUnavailable() {
            return this.status === 'unavailable'
        },

        statusAvailable() {
            return this.status === 'available' || this.status === 'available-third-party' || this.status === 'setup-fee'
        },

        statusForecast() {
            return this.status === 'forecast'
        },

        statusReview() {
            return this.status === 'review' || this.status === 'budget'
        },
    }
}
